// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2du-p","header":"PatientQuestionnaire_header__Axj7Q","info":"PatientQuestionnaire_info__1ezfi"};